export type BaseItem = { id: number }

export function useSelectedItemMixin<T extends BaseItem>(baseStore: any) {
  const updateSelectedItems = (checkBoxValue: boolean, filteredItems: T[]) => {
    if (checkBoxValue) {
      filteredItems.forEach((item) => {
        if (!baseStore.selectedItems.value.includes(item)) {
          baseStore.selectedItems.value.push(item)
        }
      })
    } else {
      filteredItems.forEach((item) => {
        const index = baseStore.selectedItems.value.findIndex(
          (selectedItem: T) => selectedItem.id === item.id
        )
        if (index !== -1) {
          baseStore.selectedItems.value.splice(index, 1)
        }
      })
    }
  }

  const clearSelectedItems = () => {
    baseStore.selectedItems.value = []
  }

  const deleteSelectedItems = () => {
    baseStore.openDeleteDialog()
  }

  return {
    updateSelectedItems,
    deleteSelectedItems,
    clearSelectedItems
  }
}
